import axios from "axios";
import { BASE_URL } from "../../../constant/server";

export const authUser = async (payload) => {
  return axios.post(BASE_URL + "v1.0/user/auth", payload);
};
